<template>
  <modal-default
    ref="modal"
    title="Potential Duplicate Leads"
    :short-circuit-close="true"
    is-double-column
  >
    <p class="duplicate_lead--message">The lead{{isPlural ? 's' : ''}} below may be a duplicate of this lead. Would you like to do with {{isPlural ? 'these' : 'this'}} lead{{isPlural ? 's' : ''}}?</p>

    <div>
      <div v-for="lead in duplicateLeads" :key="lead.record_id" class="duplicate_lead">
        <div>
          <p class="duplicate_lead--status">{{ lead.status_label }}</p>
          <p class="duplicate_lead--address">{{ lead.address }}</p>
        </div>

        <div class="duplicate_lead--buttons">
          <button-outlined @click="openMergeLeadModal(lead.record_id)">
            Compare Lead
          </button-outlined>
          <button-outlined
            class="ml-50"
            @click="markAsNotDuplicate(lead.record_id)"
            :loading="isLoading"
          >
            Not a Duplicate
          </button-outlined>
        </div>
      </div>
    </div>
  </modal-default>
</template>

<script>
import {defineComponent} from 'vue'
import {appendModal} from "../../services/modals";
import MergeDuplicateLeadModal from "./MergeDuplicateLeadModal.vue";
import api from "../../api";

export default defineComponent({
  name: "DuplicateLeadsListModal",
  props: {
    currentLeadId: {
      type: String | Number,
      required: true,
    },
    duplicateLeads: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  mounted() {
    this.$refs.modal.open();
  },
  computed: {
    isPlural() {
      return this.duplicateLeads.length > 1
    },
  },
  methods: {
    openMergeLeadModal(duplicateLeadId) {
      let $mergeLeadModal = appendModal(
        MergeDuplicateLeadModal,
        this,
        {
          currentLeadId: parseInt(this.currentLeadId),
          duplicateLeadId: parseInt(duplicateLeadId),
        });

      $mergeLeadModal.$on("reloadList", () => {
        this.$emit('reloadList')
      })
    },
    markAsNotDuplicate(duplicateLeadId) {
      this.isLoading = true
      api.contacts.markNotDuplicate(this.currentLeadId, duplicateLeadId)
        .then(res => {
          this.isLoading = false
          this.$emit('reloadList')
          this.$buefy.toast.open({
            message: 'Lead was marked as not duplicate',
            type: 'is-success'
          })
        })
    }
  },
})
</script>

<style scoped lang="scss">
@import "../../styles/variables/variables";

.duplicate_lead--message {
  margin-bottom: 1rem;
  line-height: 1.3;
}

.duplicate_lead {
  padding: 0.5rem 0;
  border-top: 1px solid $border;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:first-child {
    border-top: none;
  }

  &--status {
    margin-bottom: 4px;
    font-size: 0.75rem;
  }

  &--address {
    font-weight: bold;
  }

  &--buttons {
    display: flex;
    align-items: center;
  }
}
</style>
